
import Auth from "@/lib/common/auth";
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash-es";
import Loading from "../../components/loading.vue";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetAllForm } from "@/lib/form/exam/ExamListForm";
import { Log, LogParam, SendParam } from "@/lib/model/message/MsgRequest";
import TablePop from "@/components/table-pop.vue";
import { CompanyConfig } from "@/lib/common/acm";

class PageSizeOptions {
  value = 10;
}
class ExamItem {
  id = 0;
  name = "";
  remark = "";
  isEnableAi = true;
  examTypeFlag = true;
}

@Component({
  components: {
    Loading,
    TablePop
  }
})
export default class MessageList extends Vue {
  listParam = new LogParam();
  sendParam = new SendParam();
  name = "export-list";
  tableLoading = false;
  page = 1;
  currentPageSize = 10;
  total = 0;
  loadingList = true;
  examId = 0;
  selectedRowList: any[] = [];
  mobileSendStatusList = -1;
  emailSendStatusList = -1;
  showSendAskDialog = false;
  dialogTitle = "标题";
  dialogConcent = "内容";

  loading = false;
  batchLoading = false;

  messageMultiRadio = true;
  emailMultiRadio = false;
  selectAll = false;

  pageSizeOptions: PageSizeOptions[] = [
    { value: 10 },
    { value: 20 },
    { value: 50 },
    { value: 100 }
  ];

  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };
  list: any[] = [];

  candidateTag = [];
  examAll: ExamItem[] = new Array<ExamItem>();

  candidateSubmitStatus = 0;
  showNameOrPhone = "";

  get fuzzySearch() {
    return CompanyConfig.getInstance().fuzzySearch === 1;
  }

  created() {
    this.examId = Number(this.$route?.query?.toExamId || 0);
    this.getExamAll();
  }

  mounted() {
    this.getLogList();
  }
  toManage() {
    this.$router.push("/messageTemp/list");
  }
  getRowKeys(row: any) {
    return row.logId;
  }
  //是否可发
  canSend(row: any) {
    // 答题中、打分中-----不可任何通知

    // 未登记、已登记-----面试邀请通知
    // 已交卷（通过、拒绝）-----面试通过通知、面试拒绝通知
    const r2 = ![1].includes(row.submitStatus);

    const r1 = [0, 3].includes(row.submitStatus) && row.env === 1;
    const r3 = [1, 3].includes(row.auditStatus) && [2, 3].includes(row.env);
    return r2 && (r1 || r3);
  }
  //单发
  showMessageDialog(type: string, row: any) {
    if (type === "message") {
      this.sendParam.sendMobile = true;
      this.sendParam.sendEmail = false;
      this.dialogTitle = "发送短信通知";
      this.dialogConcent = "向候选人发送短信通知";
    } else {
      this.sendParam.sendMobile = false;
      this.sendParam.sendEmail = true;
      this.dialogTitle = "发送邮件通知";
      this.dialogConcent = "向候选人发送邮件通知";
    }
    this.sendParam.logId = row.logId;
    this.showSendAskDialog = true;
  }
  handleSelectionChange(e: any) {
    this.selectedRowList = e;
  }
  //切换全选
  changeSelectAll(selected: boolean) {
    (this.$refs.multipleTable as any)?.clearSelection();
    if (selected) {
      (this.$refs.multipleTable as any)?.toggleAllSelection();
    }
  }
  //单发接口
  sendAskSubmit() {
    if (this.loading) return;
    this.loading = true;
    Log.sendAsk(this.sendParam)
      .then(resp => {
        if (resp.code === 0) {
          this.$message.success("提交成功");
          this.showSendAskDialog = false;
          // this.getCandidateList();
        } else {
          this.$message.error(resp.message);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
  //群发接口
  async sendAskSubmitMulti() {
    if (this.batchLoading) return;
    if (this.selectAll) {
      //全选、
      if (this.total > 2000) {
        this.$message.warning("单次最多通知【前2000条】");
      }
      this.sendParam.logIdList = await this.getAllId();
    } else {
      //多选
      this.sendParam.logIdList = this.selectedRowList.map(r => {
        return r.logId;
      });
    }
    this.batchLoading = true;
    this.sendParam.sendEmail = this.emailMultiRadio;
    this.sendParam.sendMobile = this.messageMultiRadio;
    Log.sendAskMulti(this.sendParam)
      .then(resp => {
        if (resp.code === 0) {
          this.$message.success("提交成功");
          this.showSendAskDialog = false;
          // this.getCandidateList();
        } else {
          this.$message.error(resp.message);
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.batchLoading = false;
        }, 1000 * 20); // 锁 20 秒
      });
  }
  canRefresh = true;
  //刷新
  f5() {
    if (this.canRefresh === true) {
      this.getLogList("toFirst", true);
      this.canRefresh = false;
      setTimeout(() => {
        this.canRefresh = true;
      }, 1000);
    } else {
      // this.$message.warning("太频繁啦");
      return;
    }
  }

  //加载列表
  getLogList(flag?: string, tip = false, clearSelected = true) {
    if (flag === "toFirst") {
      this.page = 1;
      this.listParam.page = this.page;
    }
    if (clearSelected) {
      (this.$refs.multipleTable as any)?.clearSelection();
    }
    this.tableLoading = true;
    this.listParam.examId = this.examId;

    this.listParam.companyId = parseInt(Auth.companyId);
    this.listParam.pageSize = this.currentPageSize;
    this.listParam.mobileSendStatusList = [this.mobileSendStatusList];
    this.listParam.emailSendStatusList = [this.emailSendStatusList];

    if (this.fuzzySearch) {
      this.listParam.searchKeyLike = this.showNameOrPhone;
    } else {
      this.listParam.showNameOrPhoneOrEmail = this.showNameOrPhone;
    }

    this.loadingList = true;
    Log.getList(this.listParam)
      .then(res => {
        if (res.code === 0) {
          this.total = res.data.count;
          this.tableLoading = false;
          this.loadingList = false;
          this.list = res.data.list;
          if (tip) {
            this.$message.success("刷新成功");
          }
        }
      })
      .finally(() => {
        //
      });
  }
  //查询所有id
  async getAllId() {
    return await Log.getAllId(this.listParam).then(res => {
      if (res.code === 0) {
        return res.data.logIdList || [];
      }
    });
  }

  //所有面试
  getExamAll() {
    const p = new ExamGetAllForm();
    p.companyId = parseInt(Auth.companyId);
    this.examAll = [];
    const defaultExam = new ExamItem();
    defaultExam.id = 0;
    defaultExam.name = "全部面试";
    defaultExam.remark = "";
    defaultExam.isEnableAi = false;
    defaultExam.examTypeFlag = false;
    this.examAll.push(defaultExam);
    ExamList.examGetAll(p).then(res => {
      res.list.forEach((examRes: any) => {
        const tempInfo = new ExamItem();
        tempInfo.id = examRes.examId;
        tempInfo.name = examRes.name;
        tempInfo.remark = examRes.remark;
        tempInfo.isEnableAi = examRes.companySpecialConfig?.isEnableAi == 1;
        tempInfo.examTypeFlag = examRes.examType !== "test";
        this.examAll.push(tempInfo);
      });
    });
  }

  formatStatus(status: number) {
    switch (status) {
      case 0:
        return "等待结果";
      case 1:
        return "发送成功";
      case 2:
        return "发送失败";
      case 255:
        return "未发送";
    }
  }
}
